<template>
  <v-dialog
    v-model="active"
    width="480"
    persistent
  >
    <v-card
      v-if="derivacion"
      class="card"
      color="primary"
    >
      <v-card-title>Emisión de resultados de evaluación</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="derivacionForm"
        >
          <v-text-field
            v-model="derivacion.oficioRespuesta"
            label="Número de oficio de libreación (opcional)"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
          />
          <v-menu
            v-model="menuFechaRespuesta"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                :value="computedFechaRespuesta"
                label="Fecha de liberación de expediente"
                prepend-icon="mdi-calendar"
                readonly
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="derivacion.fechaOficioRespuesta"
              @input="menuFechaRespuesta = false"
            />
          </v-menu>
          <v-divider class="my-4" />
          <v-text-field
            v-model="derivacion.resultado"
            label="Resultado"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="required"
          />
          <v-textarea
            v-model="derivacion.observaciones"
            label="Observaciones (Opcional)"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            no-resize
            rows="4"
          />
          <ASelect
            v-model="derivacion.fk_idCatEstatus"
            label="Estatus"
            :items="estatusDerivaciones"
            item-value="id"
            item-text="title"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          text
          color="error"
          @click="closeDialog()"
        >
          Cerrar
        </v-btn>
        <v-btn
          rounded
          color="secondary"
          :disabled="loading || !derivacionForm"
          @click="triggerUpdateDerivacion()"
        >
          Emitir resultados
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import ASelect from '../atoms/ASelect.vue';

export default {
  components: {
    ASelect,
  },

  props: {
    active: {
      type: Boolean,
    },

    derivacion: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      menuFechaRespuesta: false,
      menuFechaSolicitud: false,
      file: null,
      fileSolicitud: null,
      derivacionForm: false,
      required: [(v) => !!v || 'Este campo es requerido'],
      loading: false,
    };
  },

  computed: {
    ...mapGetters('estatusDerivaciones', {
      estatusDerivaciones: 'getEstatusDerivaciones',
    }),

    computedFechaRespuesta() {
      return this.derivacion.fechaOficioRespuesta ? moment(this.derivacion.fechaOficioRespuesta).format('DD/MM/YYYY') : '';
    },
  },

  methods: {
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),

    closeDialog() {
      this.$refs.form.resetValidation();
      this.$emit('close');
    },

    async triggerUpdateDerivacion() {
      this.loading = true;
      this.derivacion.file = this.file;
      await this.updateDerivacion({
        fk_idProgramacion: this.derivacion.fk_idProgramacion,
        fechaAtendio: moment().format('DD/MM/YYYY'),
        idDerivacion: this.derivacion.idDerivacion,
        oficioSolicitud: this.derivacion.oficioSolicitud,
        fechaOficioSolicitud: this.derivacion.fechaOficioSolicitud,
        fk_idEquipoApplication: this.derivacion.fk_idEquipoApplication,
        fk_idCatEstatus: this.derivacion.fk_idCatEstatus,
        oficioRespuesta: this.derivacion.oficioRespuesta,
        fechaOficioRespuesta: moment(this.derivacion.fechaOficioRespuesta).format('DD/MM/YYYY'),
        resultado: this.derivacion.resultado,
        fechaCerro: this.derivacion.fechaCerro,
        observaciones: this.derivacion.observaciones,
      });

      await this.fetchDerivacionesByArea(this.derivacion.fk_idEquipoApplication);
      this.loading = false;

      this.closeDialog();
    },
  },
};
</script>
